module.exports = "/img/_/_/_/assets/images/creeper/battle/common//4.jpg?03dedf13c48b7d3b3f151be4d6cabaf1";